<div *ngIf="loadComplete" class="container-block">

  <ng-container *ngIf="!isViewAll">
    <app-position-in-config [elementChoosing]="objectChoosing" [device]="device"></app-position-in-config>

    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config [device]="device" [elementChoosing]="objectChoosing"
      [width]="class['frame-product-detail']['width']" [height]="class['frame-product-detail']['min-height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Cấu hình tái sử dụng thiết kế-->

      <li nz-submenu nzTitle="{{'thong_so_co_ban' | translate}}" [(nzOpen)]="openMenu.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="main-config">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>

          <!-- Chọn option nền cho frame blank -->
          <app-background-image-config [showImageConfig]="false" [config]="config" [class]="class"
            [backgroundClass]="class['frame-product-detail']" [backgroundConfig]="config['frame-product-detail']"
            [id_object]="objectChoosing._id" [isBlock]="false" [device]="device">
          </app-background-image-config>
        </div>
      </li>

      <!-- Cấu hình đường viền chung -->
      <li nz-submenu nzTitle="{{'chon_nhom_tra_cuu' | translate}}" [(nzOpen)]="openMenu.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <mat-form-field appearance="fill">
          <mat-select [(ngModel)]="staticdata.lookup_group" (ngModelChange)='updateStaticdata()'>
            <mat-option *ngFor="let lk of lookUp" [value]="lk">
              {{lk}}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </li>

      <!-- Cấu hình khi không tìm thấy sản phẩm -->
      <li nz-submenu nzTitle="{{'cau_hinh_khi_khong_tim_thay_san_pham' | translate}}" [(nzOpen)]="openMenu.menu4"
        (nzOpenChange)="openHandler('menu4')" class="word-wrap">
        <div class="d-flex justify-content-between align-items-center p-3">
          <p>{{'cau_hinh' | translate}}</p>
          <nz-switch [(ngModel)]="config['is_empty']" (ngModelChange)="updateConfig()"></nz-switch>
        </div>
        <ng-container *ngIf="config['is_empty']">
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'noi_dung' | translate}}</mat-label>
              <textarea matInput [(ngModel)]="objectChoosing.staticdata.no_data" (blur)="updateStaticdata()"></textarea>
            </mat-form-field>
          </div>

          <app-text-format-config [device]="device" [objectChoosing]="objectChoosing"
            [staticdata]="objectChoosing.staticdata" [class]="class" [config]="config"
            [textContentClass]="class['frame-product-detail__no-data']"
            [textWrapperClass]="class['frame-product-detail__no-data']">
          </app-text-format-config>

          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title">{{'gian_cach_chu' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                    class['frame-product-detail__no-data']['letter-spacing'] | vhnumber
                  " (nzBlur)="updateClass()" (ngModelChange)="
                    class['frame-product-detail__no-data']['letter-spacing'] = $event + 'px'
                  "></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="30"
              [ngModel]="class['frame-product-detail__no-data']['letter-spacing'] | vhnumber"
              (nzOnAfterChange)="updateClass()" (ngModelChange)="
                  class['frame-product-detail__no-data']['letter-spacing'] = $event + 'px'
                "></nz-slider>
          </div>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title"> {{'khoang_cach_dong' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="3" [ngStyle]="{ width: '40%' }" [nzStep]="0.1"
                [(ngModel)]="class['frame-product-detail__no-data']['line-height']"
                (nzBlur)="updateClass()"></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="3" [nzStep]="0.1"
              [(ngModel)]="class['frame-product-detail__no-data']['line-height']"
              (nzOnAfterChange)="updateClass()"></nz-slider>
          </div>
        </ng-container>
      </li>

      <!-- canh lề -->
      <li nz-submenu nzTitle="{{'canh_le' | translate}}" nzIcon="" [(nzOpen)]="openMenu.menu5"
        (nzOpenChange)="openHandler('menu5')">
        <div>
          <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classPadding]="class['frame-product-detail']" [paddingConfigs]="[
              { type: 'top' },
              { type: 'bottom' },
              { type: 'left' },
              { type: 'right' }
            ]">
          </app-padding-config>
        </div>
      </li>
      <!-- Cấu hình đường viền chung -->
      <li nz-submenu nzTitle="{{'duong_vien_chung' | translate}}" [(nzOpen)]="openMenu.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['frame-product-detail']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="item-border" style="float: right;">
          <p class="m-0 title-border" (click)="openViewAll(stylesField[0])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <div class="editor-header">
      <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
      <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
    </div>
    <!-- Cấu hình chi tiết viền của frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['frame-product-detail']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>